import { SelectProps } from '@mantine/core';
import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { useMilestoneTemplates } from 'src/api/queries/milestoneTemplates/useMilestoneTemplates';

export interface IMilestoneTemplateSelectorProps
  extends Omit<SelectProps, 'data'> {
  value: string | null;
  onChange: (value: string | null) => void;
}

/** @registry Select dropdown of milestone templates, used when creating/editing a job. */
export const MilestoneTemplateSelector: React.FC<
  IMilestoneTemplateSelectorProps
> = ({
  value,
  onChange,
  label = 'Milestone Template',
  placeholder = 'Select a milestone template...',
  ...props
}) => {
  const { data: templates, isLoading } = useMilestoneTemplates();

  const templateOptions = React.useMemo(
    () =>
      (templates ?? []).map((template) => ({
        value: template.id,
        label: template.name,
      })),
    [templates],
  );

  return (
    <Select
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      data={templateOptions}
      disabled={isLoading}
      clearable
      searchable
      {...props}
    />
  );
};
